import './style.scss';

import { faCircleExclamation, faXmark } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Chip } from '@mui/material';

import { gray, white } from '../../theme/colors';

interface IChipProperties {
  series: seriesData;
  callBack?: () => void;
  onClick?: () => void;
  onDelete?: () => void;
  removable?: boolean | true;
  disabled?: boolean | false;
  icon?: React.ReactElement;
  label?: string;
  classnames?: string;
}

interface seriesData {
  color: string;
  label: string;
  currency?: string;
  error?: boolean;
}

export default function VolSeriesChip(props: IChipProperties) {
  const { series, callBack, removable, onClick, disabled, onDelete, icon, label, classnames } =
    props;

  const handleDelete = () => {
    if (onDelete && removable) {
      onDelete();
      return;
    }

    if (onClick) {
      onClick();

      return;
    }
    if (callBack) callBack();
  };

  const handleOnClick = () => {
    if (onClick) onClick();
  };

  const otherProps = {
    deleteIcon: <FontAwesomeIcon icon={faXmark} />,
  };

  const hasIcon = !!icon;
  const getLabel = () => {
    let str = '';

    const cleanCurrency = (currency: string) => {
      const parts = currency.split('_');
      return parts[0];
    };

    if (series.currency) {
      str += `${cleanCurrency(series.currency)} `;
    }

    str += series.label;

    return str;
  };

  const getIcon = () => {
    if (series.error) {
      return <FontAwesomeIcon icon={faCircleExclamation} className="error-icon" />;
    }

    return icon;
  };

  return (
    <Chip
      label={label || getLabel()}
      onDelete={handleDelete}
      onClick={handleOnClick}
      {...(removable ? otherProps : null)}
      sx={{
        borderLeft: 'solid 3px',
        borderLeftColor: series.color,
        '& .MuiChip-deleteIcon': {
          fontSize: '1rem',
          padding: '0.5rem',
          gap: '0.5rem',
          margin: 0,
          color: gray[6],
        },
        '& .MuiChip-deleteIcon:hover': {
          color: white,
        },
        '& .MuiChip-label': !hasIcon
          ? {
              padding: 0,
              paddingLeft: '6px',
            }
          : {
              paddingLeft: '6px',
            },
        '& .MuiChip-icon': {
          color: 'white',
          width: '16px',
          height: '16px',
          padding: '2px',
          margin: 0,
        },
      }}
      icon={getIcon()}
      className={`series-chip ${classnames || ''} ${disabled || series.error ? 'disabled' : ''}`}
    ></Chip>
  );
}
